module.exports = __webpack_public_path__ + "img/1.9b897a54.jpg";